<template>
  <w-dialog :dialog-state="dialogState" :top="50" @handleClose="handleClose">
    <div class="download-app-content" slot="content">
      <h1>下载 APP</h1>
      <span class="desc">扫码下载 APP，随时随地和 HR 沟通</span>
      <img src="https://files.wondercv.com/appDownloadIcon.png" alt="">
<!--      <span class="download-app-description">下载 APP 获取更多校友资源</span>-->
    </div>
  </w-dialog>
</template>

<script>
	import WDialog from '../../../../components/base/dialog'

	export default {
		name: 'downloadAppByResume',
		props: {
			dialogState: {
				type: Boolean,
				default: false
			}
		},
		data () {
			return {}
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {
			WDialog
		},
		methods: {
			handleClose () {
				this.$emit('handleClose')
			}
		}
	}
</script>

<style lang="scss" scoped>
  .download-app-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 340px;
    height: 335px;
    padding: 26px 0;
    background-color: #FFffff;
    border-radius: 10px;
    box-shadow: 0 2px 8px 0 rgba($color: #000000, $alpha: .13);
    box-sizing: border-box;
    h1 {
      color: #404040;
      line-height: 32px;
      font-weight: 500;
      font-size: 24px;
      margin-bottom: 12px;
    }
    .desc {
      font-weight: 400;
      color: #9C9C9C;
      line-height: 22px;
      margin-bottom: 26px;
    }
    img {
      width: 176px;
      height: 176px;
      /*margin-bottom: 10px;*/
    }
    .download-app-description {
      font-weight: 400;
      color: #9C9C9C;
      line-height: 20px;
    }
  }
</style>